import { clientId, operonIdUrl, redirectUrl } from '../settings';

export function logIn() {
	window.open(
		operonIdUrl +
			'authorize.php?response_type=code&client_id=' +
			clientId +
			'&redirect_uri=' +
			redirectUrl,
		'_self'
	);
}

export function logOut(redirect = redirectUrl) {
	window.open(`http://id.operon.pl/simplesaml/user_logout.php?return_url=${redirect}`, '_self');
}

export function signIn() {
	window.open('https://id.operon.pl/simplesaml/module.php/operonid/register.php', '_self');
}

export function myAccount() {
	window.open('http://konto.operon.pl', '_blank');
}
